import { Projection } from 'src/entities/description/EntityDescription';
import { action } from 'src/redux/actions';

export const CREATE_EVENT_WITH_DEFAULT_BUNDLE = 'CREATE_EVENT_WITH_DEFAULT_BUNDLE';

export const createEventWithDefaultBundle = (data: any, projection: Projection = Projection.NONE) =>
	action(CREATE_EVENT_WITH_DEFAULT_BUNDLE, { data, projection });
